import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './styles/index.css';
import { AuthProvider } from './app/AuthProvider';
import { routes } from './app/routes';
import { SiteModeProvider } from './app/SiteModeProvider';
import { ToastProvider } from './components/ui/Toast';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
});
const router = createBrowserRouter(routes);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <SiteModeProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </SiteModeProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
